import store from '../../store'
import axios from 'axios'
async function loginRouter(to, from, next) {
  let url = store.state.api + '/Admin/CheckLogin'
  // let url = '/admin/api/Admin/CheckLogin'
  let res = await axios.post(url)
  switch (res.data.resultCode) {
    case '10':
      // 如果已登入，打開 app 首頁
      store.state.user.isLogin = true
      next({ name: 'Admin' })
      break
    case '01':
      // 如果未登入，導入 Login 頁面
      next({ name: 'Login' })
    default:
      throw new Error('嘗試於伺服器驗證登入狀態時，獲得未知的回傳代碼')
  }
}

export default { loginRouter }
